/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/services/workflowMasterService.js
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Workflow Master
 *
 * PURPOSE:
 * Frontend API Client for Workflow Master
 *
 * ARCHITECTURE:
 * • Axios Client
 * • No Business Logic
 * • Returns Backend Response Data
 ******************************************************************************/

import axiosClient from "../../../../api/axiosClient";

/**
 * --------------------------------------------------------------------------
 * GET WORKFLOWS
 * --------------------------------------------------------------------------
 *
 * Backend:
 * GET /api/expense-management/workflow/list
 */
async function getWorkflows(
  params = {}
) {

  const res = await axiosClient.get(
    "/api/expense-management/workflow/list",
    {
      params,
    }
  );

  return res.data.data || [];
}

/**
 * --------------------------------------------------------------------------
 * GET WORKFLOW DETAILS
 * --------------------------------------------------------------------------
 *
 * Backend:
 * GET /api/expense-management/workflow/details/:workflowId
 */
async function getWorkflow(
  workflowId
) {

  const res = await axiosClient.get(
    `/api/expense-management/workflow/details/${workflowId}`
  );

  return res.data.data;
}

/**
 * --------------------------------------------------------------------------
 * CREATE WORKFLOW
 * --------------------------------------------------------------------------
 *
 * Backend:
 * POST /api/expense-management/workflow/create
 */
async function createWorkflow(
  payload
) {

  const res = await axiosClient.post(
    "/api/expense-management/workflow/create",
    payload
  );

  return res.data.data;
}

/**
 * --------------------------------------------------------------------------
 * UPDATE WORKFLOW
 * --------------------------------------------------------------------------
 *
 * Backend:
 * PUT /api/expense-management/workflow/update/:workflowId
 */
async function updateWorkflow(
  workflowId,
  payload
) {

  const res = await axiosClient.put(
    `/api/expense-management/workflow/update/${workflowId}`,
    payload
  );

  return res.data.data;
}

/**
 * --------------------------------------------------------------------------
 * DELETE WORKFLOW
 * --------------------------------------------------------------------------
 *
 * Backend:
 * DELETE /api/expense-management/workflow/delete/:workflowId
 */
async function deleteWorkflow(
  workflowId
) {

  const res = await axiosClient.delete(
    `/api/expense-management/workflow/delete/${workflowId}`
  );

  return res.data;
}

/**
 * --------------------------------------------------------------------------
 * ACTIVATE WORKFLOW
 * --------------------------------------------------------------------------
 *
 * Backend:
 * PATCH /api/expense-management/workflow/activate/:workflowId
 */
async function activateWorkflow(
  workflowId
) {

  const res = await axiosClient.patch(
    `/api/expense-management/workflow/activate/${workflowId}`
  );

  return res.data.data;
}

/**
 * --------------------------------------------------------------------------
 * DEACTIVATE WORKFLOW
 * --------------------------------------------------------------------------
 *
 * Backend:
 * PATCH /api/expense-management/workflow/deactivate/:workflowId
 */
async function deactivateWorkflow(
  workflowId
) {

  const res = await axiosClient.patch(
    `/api/expense-management/workflow/deactivate/${workflowId}`
  );

  return res.data.data;
}

/**
 * --------------------------------------------------------------------------
 * EXPORT
 * --------------------------------------------------------------------------
 */

const workflowMasterService = {

  getWorkflows,

  getWorkflow,

  createWorkflow,

  updateWorkflow,

  deleteWorkflow,

  activateWorkflow,

  deactivateWorkflow,

};

export default workflowMasterService;